import Vue from 'vue';
import VueCookies from 'vue-cookies';
// Registro de Cookies
Vue.use(VueCookies);
export const state = {
    redirectUrl: Vue.$cookies.get('redirectUrl') != undefined ? Vue.$cookies.get('redirectUrl') : ''
};
export const mutations = {
    SET_REDIRECT_URL(state, url) {
        Vue.set(state, 'redirectUrl', url);
        state.redirectUrl = url;
        Vue.$cookies.set('redirectUrl', state.redirectUrl);
    }
};
export const actions = {
    setRedirectUrl({ commit }, url) {
        commit('SET_REDIRECT_URL', url);
    }
};
